import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import axios from "axios";
import { reportUnitPerformanceTypes } from "redux/reducers/Reports/reportUnitPerformance/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_UNIT_PERFORMANCE_FILTERS } = reportUnitPerformanceTypes;

export const getReportUnitPerformanceAction = ({ startDate, endDate, station, isPdf = true }) => {
  const token = localStorage.getItem('crm-user');
  const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/carburations/report-unitPerformance/${station.id}?initDate=${startDate}&endDate=${endDate}&pdf=${isPdf}`;
  const fileName = `Reporte_Rendimiento_Unidades_${station.name}_${startDate}_${endDate}.${isPdf ? "pdf" : "xlsx"}`;

  return async dispatch => {
    dispatch(startRequestComp('loadingUnitPerformance'));
    try {
      const file = await axios({
        url: reportUrl,
        method: 'GET',
        responseType: 'blob',
        headers: { authorization: token }
      });

      saveAs(file.data, fileName);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingUnitPerformance'));
    }
  };
};

export const setReportUnitPerformanceFilters = (key = "", value) => ({
  type: SET_UNIT_PERFORMANCE_FILTERS,
  payload: { key, value }
});
